import { create } from 'zustand';
import { bookingsAPI } from '../api/services';

const useBookingStore = create((set) => ({
  bookings: [],
  booking: null,
  loading: false,
  error: null,
  pagination: { current: 1, pageSize: 15, total: 0 },

  fetchBookings: async (params = {}) => {
    set({ loading: true });
    try {
      const res = await bookingsAPI.getAll(params);
      const data = res.data?.data || res.data;
      set({
        bookings: Array.isArray(data) ? data : data?.data || [],
        pagination: {
          current: data?.current_page || 1,
          pageSize: data?.per_page || 15,
          total: data?.total || 0,
        },
        loading: false,
      });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  fetchBooking: async (id) => {
    set({ loading: true });
    try {
      const res = await bookingsAPI.getOne(id);
      set({ booking: res.data?.data || res.data, loading: false });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  deleteBooking: async (id) => {
    await bookingsAPI.delete(id);
  },
}));

export default useBookingStore;
